import { parse } from "papaparse";
import { orderTypeExceptionValidations } from "./schemas/order-type-exception-validations"; //M10-12407
import { getOrderTypeExceptionValidation } from "src/services/oms-api"; //M10-12407

export const validateOrderTypeExpBulkFile = async (fileList: FileList, selectedData: any): Promise<any | void> => {
  const fileToParse = fileList[0];
  const fileReader = new FileReader();

  return new Promise((resolve, reject) => {
    fileReader.onload = async (e: any) => {
      if (e.target && e.target.result) {
        let parsedResult: any = parse(e.target.result as any, {
          header: true,
          //@ts-ignore
          encoding: "utf-8",
          skipEmptyLines: true,
          dynamicTyping: true,
        });
        let cleanedData = [];

        for (let item of parsedResult.data) {
          let isNull = true;
          for (let key in item) {
            if (item[key] !== null) {
              isNull = false;
              break;
            }
          }
          if (isNull) {
            break;
          } else {
            //item.mobileNumber = item.mobileNumber || [];
            cleanedData.push(item);
          }
        }

        parsedResult = cleanedData;
        console.log("parsedResult", parsedResult);
        console.log(selectedData?.select_type?.select_type);
        // console.log(selectedData.code.code);
        let errors: any[] = [];
        let valid: any[] = [];
        let schemaFields: any[] = [];
        let parsedFields: any[] = [];
        let missingFields: any[] = [];
        let schema: any;

        switch (selectedData?.select_type?.select_type) {
          //M10-12407
          case "bulkOrderTypeException":
            errors = [];
            valid = [];
            schema = orderTypeExceptionValidations(selectedData);

            // check column schema first
            schemaFields = Object.keys(schema.fields);
            parsedFields = Object.keys(parsedResult[0]);
            missingFields = schemaFields.filter((field) => !parsedFields.includes(field));
            if (missingFields.length > 0) {
              return reject([
                {
                  success: false,
                  message: "Make sure you are entering right template with right column names",
                },
              ]);
            }

            //  validate each row
            await Promise.all(
              parsedResult.map(async (row: any) => {
                try {
                  await schema.validate(row, { abortEarly: false });
                } catch (validationError) {
                  const castedError = validationError as any;
                  errors.push({ ...row, message: castedError.errors, success: false });
                }
              })
            );

            if (errors.length > 0) {
              reject(errors);
            } else {
              getOrderTypeExceptionValidation(parsedResult)
                .then((res: any) => {
                  console.log("API Response:", res);

                  if (!res || !res.data) {
                    return reject([{ success: false, message: "Empty response from server" }]);
                  }

                  const { success, message, data, errors } = res.data;

                  if (success && Array.isArray(data)) {
                    valid.push(...data);
                    console.log("All records valid:", message);
                    return resolve(valid);
                  }

                  if (!success && Array.isArray(errors) && errors.length > 0) {
                    const formattedErrors = errors?.filter((errMsg: any) => errMsg?.Message?.trim() !== "")?.map((errMsg: any) => ({ //M10-12059
                      success: false,
                      counterCode: errMsg?.counterCode,
                      counterLinkType: errMsg?.counterLinkType,
                      orderType: errMsg?.orderType,
                      companyCode: errMsg?.companyCode,
                      companyDivisionCode: errMsg?.companyDivisionCode,
                      message: errMsg?.Message,
                    }));
                    console.log("Validation failed with multiple errors:", formattedErrors);
                    errors.push(...formattedErrors);
                    return reject(formattedErrors);
                  }

                  const errorObj = {
                    success: false,
                    message: message || "Validation failed",
                  };
                  console.log("Validation error:", errorObj);
                  errors.push(errorObj);
                  return reject(errors);
                })
                .catch((err: any) => {
                  console.log("API Error:", err);

                  const backendMessage =
                    err?.response?.data?.message ||
                    err?.message ||
                    "API request failed";

                  return reject([{ success: false, message: backendMessage }]);
                });
            }
            break;
          //M10-12407
          default:
            console.log("No correct key hit");
            break;
        }
      }
    };

    fileReader.onerror = (error) => {
      reject(error);
    };
    fileReader.readAsText(fileToParse, "UTF-8");
  });
};
